import { ITrialClass } from '@wot/typings';
import { BiSort } from 'react-icons/bi';
import { Table, TableBody, TableHeading, TableHeadingCol, TableRow } from '../../../../components/Table';
import TableRowItem from './TableRowItem';
import { useNavigate } from 'react-router-dom';

interface Props {
  data: ITrialClass[];
  handleSort: (key: 'createdAt' | 'name') => void;
}

export default function TableContainer({ data, handleSort }: Props) {
  const navigate = useNavigate();

  return (
    <>
      <Table>
        <TableHeading>
          <TableRow>
            <TableHeadingCol
              label="DATE"
              component={
                <div className="flex items-center">
                  <p className="">DATE</p>
                  <BiSort className="text-sm" />
                </div>
              }
              onClick={() => handleSort('createdAt')}
            />
            <TableHeadingCol label="Class ID" />
            <TableHeadingCol
              label="NAME"
              component={
                <div className="flex items-center">
                  <p className="">NAME</p>
                  <BiSort className="text-sm" />
                </div>
              }
              onClick={() => handleSort('name')}
            />
            {/* <TableHeadingCol label="EMAIL" /> */}
            <TableHeadingCol label="Subject" />
            <TableHeadingCol label="EMAIL" />
            <TableHeadingCol label="TUTOR" />
            <TableHeadingCol label="TYPE" />
            <TableHeadingCol label="STATUS" />
          </TableRow>
        </TableHeading>
        <TableBody>
          {data.map((session) => (
            <TableRow key={session._id} onClick={() => navigate(session._id)}>
              <TableRowItem session={session} />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
}
